<template>
    <!-- 微信H5获取用户的openid -->
    <div style="padding: 20px;">
        <el-card style="margin-top: 20px;">
            <div>版次信息</div>
            <div style="margin-top: 20px;">
                <el-form :model="data" label-position="left" label-width="100px">

                    <el-form-item label="批次号">
                        <el-input v-model="data.batch_id" readonly class="underline-input" />
                    </el-form-item>

                    <el-form-item label="打印机编号">
                        <el-input v-model="data.print_machine_id" readonly class="underline-input" />
                    </el-form-item>

                    <el-form-item label="模型数量">
                        <el-input v-model="data.model_counts" readonly class="underline-input" />
                    </el-form-item>

                    <el-form-item label="操作人">
                        <el-input v-model="data.nickname" readonly class="underline-input" />
                    </el-form-item>
                </el-form>
            </div>
        </el-card>

        <el-card style="margin-top: 20px;">
            <div>
                <div>当前工序</div>
                <div>
                    <el-radio-group v-model="currentProcessValue">
                        <el-radio style="margin-right: 10px;margin-top:15px;" border v-for="item in currentProcess" :key="item" :label="item">{{ item }}</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div style="text-align:center;margin-top: 20px;" v-loading="loading">
                <el-button v-if="!isSuccess" type="primary" @click="submit">确认</el-button>
            </div>
        </el-card>
    </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { ElMessage } from 'element-plus';
import 'element-plus/es/components/message/style/css';
import { useRoute } from 'vue-router';
import * as api from '@/api/multiPrint';
const loading = ref(false)
const route = useRoute();
const isSuccess = ref(false)
const data = {
    // "token": route.query.token,
    "nickname": route.query.nickname,
    "print_machine_id": route.query.machine_id,
    "model_counts": route.query.model_counts,
    "batch_id": route.query.batch_id,
    "wechat_fans_id": route.query.wechat_fans_id,
    "status": "",
}
const currentProcess = ref([
    "浸泡","剥支撑","喷砂","上油","烘干","移交"
]);
const currentProcessValue = ref("");
const submit = () => {
    data.status = currentProcessValue.value;
    console.log("请求参数",data)
    loading.value = true;
    api.confirmProcess(data).then(res => {
        isSuccess.value = true
        ElMessage.success('操作成功');
    })
    .catch(err => {
        console.log('错误信息:', err);
        const errorMessage = err?.message || err?.response?.data?.message || '操作失败';
        ElMessage.error(errorMessage);
    }).finally(() => {
        loading.value = false;
    })
}
</script>
<style scoped lang="less">
:deep(.el-form-item__label) {
    text-align: left;
    padding-right: 20px;
}

:deep(.underline-input) {
    .el-input__wrapper {
        box-shadow: none;
        border: none;
        border-bottom: 1px solid #dcdfe6;
        border-radius: 0;
        padding: 0;
        
        &:hover {
            box-shadow: none;
            border-bottom-color: #c0c4cc;
        }
        
        &.is-focus {
            box-shadow: none;
            border-bottom-color: #409eff;
        }
    }
    
    .el-input__inner {
        padding: 0;
    }
}
</style>